(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new WeakMap();
  const observed = new Set();
  const canMove = () => !reduced.matches && !document.documentElement.classList.contains('motion-none') && !window.Shopify?.designMode;
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('ww-polish-pending');
      entry.target.classList.add('ww-polish-visible');
      observer.unobserve(entry.target);
      observed.delete(entry.target);
    });
  }, {threshold:0.08,rootMargin:'0px 0px -20px 0px'}) : null;
  const selectors = '.intro-copy,.ww-moodboard__head,.ww-moodboard__tile,.ww-service-page__content>section,.house-story,.house-kindness,.house-signature,.rhyme-lines p,.rhyme-page__intro,.ww-faq__item,.main-contact__intro,.main-contact__form-wrap,.product-card-block,.woe-club';
  function init(root) {
    const sections = root.matches?.('[data-section-id]') ? [root,...root.querySelectorAll('[data-section-id]')] : [...root.querySelectorAll('[data-section-id]')];
    sections.forEach(section => {
      if (section.classList.contains('ww-polish-ready')) return;
      section.classList.add('ww-polish-ready');
      section.querySelectorAll(selectors).forEach((element,index) => {
        if (element.dataset.polish !== undefined) return;
        element.dataset.polish = '';
        element.style.setProperty('--ww-polish-delay',`${Math.min(index % 4,3)*55}ms`);
        if (!canMove() || !observer || section.dataset.wwMotion === 'none' || element.getBoundingClientRect().bottom < 0) return;
        if (element.getBoundingClientRect().top < window.innerHeight*.92) { element.classList.add('ww-polish-visible'); return; }
        element.classList.add('ww-polish-pending');
        observed.add(element);
        observer.observe(element);
      });
    });
  }
  function revealAll() {
    if (canMove()) return;
    observed.forEach(element => {element.classList.remove('ww-polish-pending');observer?.unobserve(element);});
    observed.clear();
  }
  document.addEventListener('toggle',event => {
    const details=event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !canMove() || details.closest('[data-ww-motion="none"]')) return;
    const panel=details.querySelector(':scope > .rte,:scope > .accordion__body,:scope > .letter,:scope > [data-disclosure-panel]');
    if (!panel || !panel.animate) return;
    animations.get(panel)?.cancel();
    const animation=panel.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:560,easing:'cubic-bezier(.22,.61,.36,1)'});
    animations.set(panel,animation);
  },true);
  document.addEventListener('ww:content:load',event=>{event.target.querySelectorAll('.reveal').forEach(element=>element.classList.add('is-visible','is-in','is-revealed'));init(event.target);});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{observed.forEach(element=>{if(event.target.contains(element)){observer?.unobserve(element);observed.delete(element);}});});
  document.addEventListener('shopify:block:select',event=>{event.target.closest('[data-polish]')?.classList.remove('ww-polish-pending');});
  document.addEventListener('focusin',event=>{event.target.closest('[data-polish]')?.classList.remove('ww-polish-pending');});
  reduced.addEventListener('change',revealAll);
  new MutationObserver(revealAll).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
})();

(() => {
  const init = (root = document) => {
    [...(root.matches?.('.ww-moodboard') ? [root] : []),...root.querySelectorAll('.ww-moodboard')].forEach(board => {
      if (board.dataset.ready) return;
      board.dataset.ready = 'true';
      const dialog = board.querySelector('dialog');
      board.addEventListener('click', event => {
        const opener = event.target.closest('[data-mood-open]');
        if (opener) {
          const source = opener.querySelector('img');
          const image = dialog.querySelector('img');
          image.src = opener.dataset.fullImage || source.currentSrc || source.src;
          image.alt = source.alt;
          dialog.querySelector('p').textContent = opener.closest('figure').querySelector('figcaption')?.textContent || '';
          dialog.showModal();
        }
        if (event.target.closest('[data-mood-close]')) dialog.close();
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    [...(root.matches?.('[data-ww-recommendations]') ? [root] : []),...root.querySelectorAll('[data-ww-recommendations]')].forEach(section => {
      if (section.dataset.loaded || !section.dataset.wwRecommendations) return;
      section.dataset.loaded = 'true';
      fetch(section.dataset.wwRecommendations)
        .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = doc.querySelector('[data-recommendation-grid]');
          const target = section.querySelector('[data-recommendation-grid]');
          if (grid?.querySelector('article') && target && section.isConnected) {
            target.innerHTML = grid.innerHTML;
            target.dispatchEvent(new CustomEvent('ww:content:load', {bubbles:true}));
          }
        }).catch(() => {});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animateHero = () => {
    const hero = document.querySelector('.hero');
    if (!hero || hero.dataset.entrancePlayed || reduced.matches || document.documentElement.classList.contains('motion-none') || window.Shopify?.designMode || hero.dataset.wwMotion === 'none') return;
    hero.dataset.entrancePlayed = 'true';
    const content = hero.querySelector('.hero__content');
    const picture = hero.querySelector('.hero__bg img,.hero__placeholder');
    content?.animate([{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:1100,easing:'cubic-bezier(.22,.61,.36,1)'});
    if (!document.documentElement.classList.contains('motion-restrained')) picture?.animate([{transform:'scale(1.045)'},{transform:'scale(1)'}],{duration:2200,easing:'cubic-bezier(.22,.61,.36,1)'});
  };
  document.addEventListener('ww:intro-reveal', animateHero);
  document.addEventListener('ww:intro-complete', animateHero);
  const ready = () => { if (!document.documentElement.classList.contains('ww-intro-active')) animateHero(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();

(() => {
  let watched;
  const findPreviewBar = () => {
    const frame = document.getElementById('PBarNextFrameWrapper');
    if (!frame || frame === watched) return;
    watched = frame;
    const update = () => document.documentElement.style.setProperty('--ww-preview-bar-height', `${Math.max(0,Math.ceil(frame.getBoundingClientRect().height))}px`);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(frame);
    update();
    watcher.disconnect();
  };
  const watcher = new MutationObserver(findPreviewBar);
  watcher.observe(document.documentElement,{childList:true,subtree:true});
  findPreviewBar();
  window.addEventListener('pagehide',()=>watcher.disconnect(),{once:true});
})();
